/**
 * Badge
 */

// Module Dependencies
import 'protons';

// Module template
import './_badge.twig';

// Module styles
import './_badge.scss';

export const name = 'badge';

export function disable() {}

export function enable() {}

export default enable;
